import semver from 'semver'

export const validSemver = (value, allValues) => {
  	return semver.valid(value) ? undefined : "Versions must be valid semver format"
}

export const positiveCharge = (value) => {
	return value >= 0 ? undefined : "$ value must be > 0"
}
